import axios from 'axios'
import userStore from '../stores/UserStore';
import * as _ from 'lodash'

class Api {
    constructor() {
      this.axios = axios.create({ 
        baseURL: process.env.REACT_APP_API_URL
      });
    }

    createHeaders = ()=>{
      var token = userStore.token;
      return token ? {'Authorization': `JWT ${token}`} : null;
    }

    get(path, config) {
      return this.axios.request(_.merge({
        method: 'GET',
        url: path,
        responseType: 'json',
        headers: this.createHeaders()
      }, config))
    }
  
    patch(path, payload, config) {
      return this.axios.request(_.merge({
        method: 'PATCH',
        url: path,
        responseType: 'json',
        data: payload,        
        headers: this.createHeaders()
      }, config))
    }
    delete(path, config) {
      return this.axios.request(_.merge({
        method: 'DELETE',
        url: path,
        responseType: 'json',
        headers: this.createHeaders()
      }, config))
    }
    post(path, payload, config) {
      return this.axios.request(_.merge({
        method: 'POST',
        url: path,
        responseType: 'json',
        data: payload,
        headers: this.createHeaders()        
      }, config))
    }
  }

  export default new Api()


// WEBPACK FOOTER //
// ./src/api/Api.js